export default "__VITE_ASSET__31f3a9f2__"